export default "__VITE_ASSET__CF3phxr0__"